import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import MerchantTimesheetPromoBanner from "./MerchantTimesheetPromoBanner";
import LeftSide from "./LeftSide";
import React, { useEffect } from "react";
import MainContentOffset from "./MainContentOffset";
import { RouteErrorBoundary } from "../ErrorBoundary/ErrorBoundary";
import { AdminChatbotGate } from "../Chatbot/AdminChatbot";
import "../../Styles/EmployeeList/employeeWorkspace.css";
import "../../Styles/CustomerManagement/customerWorkspace.css";

const INVENTORY_VISIBLES = new Set([
  "products",
  "new-products",
  "new-product-add",
  "new-product-edit",
  "new-product-duplicate",
  "new-product-sales",
  "product-edit",
  "product-add",
  "duplicate-product",
  "product-sales",
  "edit-varient",
  "stock-on-hand",
  "inventory-transfer",
  "bulk-product-update",
  "attributes",
  "old-attributes",
  "category",
  "add-category",
  "category-edit-cat",
  "brands",
  "old-brands",
  "tags",
  "old-tags",
  "audit-log",
  "product-lookups",
  "vendors",
  "add-vendors",
  "old-vendors",
  "new-vendor-details",
  "lottery",
  "add-lottery",
  "update-lottery",
  "inventory-merge",
]);

const EMPLOYEE_VISIBLES = new Set([
  "manage-employees",
  "manage-employee-permissions",
]);

const CUSTOMER_VISIBLES = new Set([
  "customer-management",
  "store-groups",
  "create-group",
  "edit-group",
]);

const STORE_SETTINGS_VISIBLES = new Set([
  "info",
  "zohoProductMapping",
  "setup",
  "Alters",
  "options",
  "store-setting",
  "taxes",
  "inventory",
  "register",
  "system-access",
  "breaks-and-compliance",
  "scan-data-AltriaForm",
  "scan-data-ReynoldsForm",
  "scan-data-Dezi",
  "scan-data-SyncedProducts",
  "scan-data-SentReports",
  "scan-data-ManualUpload",
  "StoreSettingloyalty-program",
  "StoreSettingloyalty-program2",
  "addemployee",
  "permission",
  "receipt",
  "Digital-marketing-tags",
  "permission-presets",
  "permission-presets-add",
  "permission-presets-edit",
  "manage-employees",
  "manage-employee-permissions",
]);

const Index = ({ visible }) => {
  const location = useLocation();
  const isTransfersPage =
    visible === "inventory-transfer" ||
    location.pathname === "/inventory/transfer" ||
    location.pathname.startsWith("/inventory/transfer/");
  const isInventoryPage = INVENTORY_VISIBLES.has(visible);
  const isEmployeePage = EMPLOYEE_VISIBLES.has(visible);
  const isCustomerPage = CUSTOMER_VISIBLES.has(visible);
  const isStoreSettingsPage = STORE_SETTINGS_VISIBLES.has(visible);
  const isOrdersNewPage =
    visible === "order-new" || visible === "order-online-new";
  const isSalesReportsPage = visible === "new-sale-report";
  const isInventoryReportsPage = visible === "inventory-report";
  const isCustomerReportsPage = visible === "customer-reports";
  const isEmployeeReportsPage = visible === "employee-reports";
  const isPaymentReportsPage = visible === "payment-report";
  const isRefundReportsPage = visible === "refund-report-main";
  const isRegisterActivityPage =
    visible === "register-closures" ||
    visible === "register-closures-summery" ||
    visible === "register-closures-transactions";
  const isLoyaltyReportsPage = visible === "detailed-loyalty-points-report";
  const isStoreCreditReportsPage = visible === "store-credit-report";
  const isGiftCardReportsPage = visible === "gift-card-report";
  const isTaxesReportsPage = visible === "new-taxes-report";
  const isLocationReportsPage = visible === "location-report";
  const isUberReportsPage = visible === "uber-reports";

  useEffect(() => {
    const root = document.documentElement;
    if (isInventoryPage) {
      root.setAttribute("data-qv-inventory", "1");
    } else {
      root.removeAttribute("data-qv-inventory");
    }
    if (isEmployeePage) {
      root.setAttribute("data-qv-employee", "1");
    } else {
      root.removeAttribute("data-qv-employee");
    }
    if (isCustomerPage) {
      root.setAttribute("data-qv-customer", "1");
    } else {
      root.removeAttribute("data-qv-customer");
    }
    if (isStoreSettingsPage) {
      root.setAttribute("data-qv-store-settings", "1");
    } else {
      root.removeAttribute("data-qv-store-settings");
    }
    return () => {
      root.removeAttribute("data-qv-inventory");
      root.removeAttribute("data-qv-employee");
      root.removeAttribute("data-qv-customer");
      root.removeAttribute("data-qv-store-settings");
    };
  }, [isInventoryPage, isEmployeePage, isCustomerPage, isStoreSettingsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isOrdersNewPage) {
      root.setAttribute("data-qv-orders", "1");
    } else {
      root.removeAttribute("data-qv-orders");
    }
    return () => root.removeAttribute("data-qv-orders");
  }, [isOrdersNewPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isSalesReportsPage) {
      root.setAttribute("data-qv-sales-reports", "1");
    } else {
      root.removeAttribute("data-qv-sales-reports");
    }
    return () => root.removeAttribute("data-qv-sales-reports");
  }, [isSalesReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isInventoryReportsPage) {
      root.setAttribute("data-qv-inventory-reports", "1");
    } else {
      root.removeAttribute("data-qv-inventory-reports");
    }
    return () => root.removeAttribute("data-qv-inventory-reports");
  }, [isInventoryReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isCustomerReportsPage) {
      root.setAttribute("data-qv-customer-reports", "1");
    } else {
      root.removeAttribute("data-qv-customer-reports");
    }
    return () => root.removeAttribute("data-qv-customer-reports");
  }, [isCustomerReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isEmployeeReportsPage) {
      root.setAttribute("data-qv-employee-reports", "1");
    } else {
      root.removeAttribute("data-qv-employee-reports");
    }
    return () => root.removeAttribute("data-qv-employee-reports");
  }, [isEmployeeReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isPaymentReportsPage) {
      root.setAttribute("data-qv-payment-reports", "1");
    } else {
      root.removeAttribute("data-qv-payment-reports");
    }
    return () => root.removeAttribute("data-qv-payment-reports");
  }, [isPaymentReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isRefundReportsPage) {
      root.setAttribute("data-qv-refund-reports", "1");
    } else {
      root.removeAttribute("data-qv-refund-reports");
    }
    return () => root.removeAttribute("data-qv-refund-reports");
  }, [isRefundReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isRegisterActivityPage) {
      root.setAttribute("data-qv-register-activity", "1");
    } else {
      root.removeAttribute("data-qv-register-activity");
    }
    return () => root.removeAttribute("data-qv-register-activity");
  }, [isRegisterActivityPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isLoyaltyReportsPage) {
      root.setAttribute("data-qv-loyalty-reports", "1");
    } else {
      root.removeAttribute("data-qv-loyalty-reports");
    }
    return () => root.removeAttribute("data-qv-loyalty-reports");
  }, [isLoyaltyReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isStoreCreditReportsPage) {
      root.setAttribute("data-qv-store-credit-reports", "1");
    } else {
      root.removeAttribute("data-qv-store-credit-reports");
    }
    return () => root.removeAttribute("data-qv-store-credit-reports");
  }, [isStoreCreditReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isGiftCardReportsPage) {
      root.setAttribute("data-qv-gift-card-reports", "1");
    } else {
      root.removeAttribute("data-qv-gift-card-reports");
    }
    return () => root.removeAttribute("data-qv-gift-card-reports");
  }, [isGiftCardReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isTaxesReportsPage) {
      root.setAttribute("data-qv-taxes-reports", "1");
    } else {
      root.removeAttribute("data-qv-taxes-reports");
    }
    return () => root.removeAttribute("data-qv-taxes-reports");
  }, [isTaxesReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isLocationReportsPage) {
      root.setAttribute("data-qv-location-reports", "1");
    } else {
      root.removeAttribute("data-qv-location-reports");
    }
    return () => root.removeAttribute("data-qv-location-reports");
  }, [isLocationReportsPage]);

  useEffect(() => {
    const root = document.documentElement;
    if (isUberReportsPage) {
      root.setAttribute("data-qv-uber-reports", "1");
    } else {
      root.removeAttribute("data-qv-uber-reports");
    }
    return () => root.removeAttribute("data-qv-uber-reports");
  }, [isUberReportsPage]);

  const arrForChangeBacgroundColorForCurrentUrl = [
    "/employee/manage-employees",
  ];
  return (
    <>
      <div
        className={`main-page-home-dashboard ${arrForChangeBacgroundColorForCurrentUrl.includes(location.pathname) ? "bg-[#f9f9fa]" : "bg-[#F9F9F9]"}`}
      >
        <MerchantTimesheetPromoBanner />
        <Header />
        {/* <AdminChatbotGate pageKey={visible} /> */}
        <div>
          <MainContentOffset
            disabled={visible === "order-summary"}
            className={`${isTransfersPage ? "qv-transfers-shell" : "main-content"}${isInventoryPage ? " qv-inventory-workspace" : ""}${isEmployeePage ? " qv-employee-workspace" : ""}${isCustomerPage ? " qv-customer-workspace" : ""}${isStoreSettingsPage ? " qv-store-settings-workspace" : ""} ${visible == "dashboard" ? "largeText" : ""}${visible === "order-summary" ? " main-content--flush" : ""}${visible === "ask-quickvee-ai" ? " main-content--ask-ai" : ""}`}
          >
            <RouteErrorBoundary variant="page">
              <Outlet />
              <LeftSide visible={visible} />
            </RouteErrorBoundary>
          </MainContentOffset>
        </div>
      </div>
    </>
  );
};

export default Index;
